import { AskMooIntegrationV2 } from '../v2/AskMooIntegrationV2';
import { DwellDetector } from '../dwell/DwellDetector';

export default function AskMooChat() {
  return (
    <>
      <AskMooIntegrationV2 />
      <DwellDetector />
    </>
  );
}
